import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
// When someone downloads their localization base file
export const Localization_FileDownload = BaseAnalyticsEvent.extend({
    name: z.literal("Localization_FileDownload"),
    properties: z.object({
        from: z.enum([
            "main",
            "paywall"
        ]).optional()
    }).optional()
});
// When someone uploads their localization base file
export const Localization_FileUpload = BaseAnalyticsEvent.extend({
    name: z.literal("Localization_FileUpload"),
    properties: z.object({
        from: z.enum([
            "main",
            "paywall"
        ]).optional()
    }).optional()
});
export const Localization_ProviderAddedOrUpdated = BaseAnalyticsEvent.extend({
    name: z.literal("Localization_ProviderAddedOrUpdated")
});
export const Localization_ProviderRemoved = BaseAnalyticsEvent.extend({
    name: z.literal("Localization_ProviderRemoved")
});
